<template>
  <div>
    <div v-if="!isMobile" class="student-selected show">
      <div class="shadow-bottom">
        <div
          class="d-flex flex-row flex-wrap"
          style="margin-top:20px; !important"
        >
          <div class="col-md-3 border-gradient">
            <div class="row">
              <div class="icon-box mt-4">
                <div>
                  <i class="fa-stack text-green icon-circle">
                    <i class="fas fa-circle fa-stack-2x icon-circle-stack" />
                    <i class="fas fa-user fa-stack-1x fa-inverse text-yellow" />
                  </i>
                </div>
              </div>
              <div
                id="dvSelectedStudentName"
                class="label-user block-separator"
              >
                {{ student.firstName }}
                <br />
                {{ student.lastName }}
              </div>
            </div>
          </div>
          <div class="col-md-1 block-separator">
            <label>SIE:</label>
            <span id="spSelectedStudentSie">{{ student.studentId }}</span>
          </div>
          <div class="col-md-2 border-gradient block-separator">
            <label>Registro:</label>
            <span>
              {{
                student.regStudentId != null
                  ? student.regStudentId
                  : 'No Disponible'
              }}
            </span>
          </div>
          <div class="col-md-3 block-separator">
            <label>Impedimento:</label>
            <span>
              {{
                student.impediment != null
                  ? student.impediment
                  : 'No Disponible'
              }}
            </span>
          </div>
          <div class="col-md-1 border-gradient block-separator">
            <label>Estatus:</label>
            <span>
              {{ student.status != null ? student.status : 'No Disponible' }}
            </span>
          </div>
          <div class="col-md-2 block-separator text-center">
            <button
              type="button"
              class="btn btn-darkgrey ml-3 btn-action button-search"
              @click="viewStudentinfo(student)"
            >
              <i class="far fa-search" />
            </button>
            <button
              type="button"
              class="btn btn-danger ml-3 btn-action-danger"
              @click="onClearSelectedStudent()"
            >
              <i class="fa fa-times-circle" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <SelectedStudentCompact
      v-if="isMobile"
      :student="student"
      @setStudentinfo="viewStudentinfo(student)"
      @onClearSelectedStudent="onClearSelectedStudent()"
    />
    <div
      class="col-12 col-md-12 justify-content-end align-items-center text-right"
    >
      <ActionButton
        v-if="false"
        variant="success"
        :text="certificationBtnText"
        i="fas fa-file-download mx-auto"
        @click="downloadCertification(student.studentId)"
      />
    </div>
  </div>
</template>
<script>
import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import SelectedStudentCompact from './SelectedStudentCompact';
import router from '@/router';
import ActionButton from 'ActionButton';
import reportService from '@/services/report';
import StudentStatuses from '@/utils/constants/student/studentStatuses';

export default {
  components: {
    SelectedStudentCompact,
    ActionButton,
  },
  props: ['student'],
  methods: {
    async onClearSelectedStudent() {
      const response = await alert.methods.ShowCancelModal(
        'Atención',
        '¿Desea cancelar la selección del estudiante?',
        'Sí',
        'No'
      );
      if (response) {
        this.$emit('DeselectedStudent');
        store.dispatch('RedirectRouter', router.currentRoute);
      }
    },
    onCloseModal() {
      this.showCancelSelectedStudent = false;
    },
    async viewStudentinfo(data) {
      await store.dispatch('$_student/setStudentDetails', {
        student: data,
        studentId: data.studentId,
        disabledToggleSearchMenu: true,
        autoCreateStudentData: false,
        viewStudentInfo: true,
        selectThisStudent: true,
      });
      this.$emit('showStudentInfo', data.studentId);
      store.commit('$_student/ChangeStatusModal'); //Show Student Info Modal
    },
    async downloadCertification(studentSieId) {
      await reportService.downloadVaccinationCertification(studentSieId);
    },
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    showVaccinationCertificate() {
      return (
        store.state.$_student.details.age >= 16 &&
        ![
          StudentStatuses.PreRegistro,
          StudentStatuses.NoElegible,
          StudentStatuses.Egreso,
          StudentStatuses.Inactivo,
        ].some(
          (x) =>
            x == store.state.$_student.details.mipeStudent.studentStatusCode
        )
      );
    },
    certificationBtnText() {
      return this.isMobile ? '' : 'Certificación de Vacuna';
    },
  },
};
</script>

<style scoped>
.icon-box {
  margin-top: 1px;
  margin-left: 5px;
  margin-right: 10px;
  font-size: 19px;
}

.col-block {
  padding-left: 40px;
}

.col-block label {
  font: Bold 16px/7px Lato;
  letter-spacing: 0;
  color: rgba(17, 41, 27, 1);
  margin-bottom: 6px;
}

.block-separator {
  padding-top: 20px;
}

.btn-action-danger {
  background: #c9545e;
}

.btn-action,
.btn-action-danger i {
  margin-left: 9px;
  margin-right: 6px;
  color: #fff;
}

.btn-action span,
.btn-action-danger span {
  color: #fff;
  font-size: 17px;
}

.icon-circle {
  width: 40px;
  height: 40px;
  border: 1px solid #2db782;
  border-radius: 100%;
  line-height: 1.8em !important;
}

.icon-circle-stack {
  font-size: 32px;
  position: absolute;
  top: 3px;
  left: 0px;
}
</style>
